module.exports = __webpack_public_path__ + "img/icon-brackets.a50937a5.svg";